import React, { Fragment } from 'react';
import axios from 'axios';
import Qs from 'qs'
import Swal from 'sweetalert2'
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Menu, Item, Separator, Submenu, MenuProvider } from 'react-contexify';
import 'react-contexify/dist/ReactContexify.min.css';
import {
    Card,
    ModalHeader,
    FormGroup,
    Input,
    Label,
    ModalFooter,
    Row,UncontrolledPopover, DropdownToggle,
    UncontrolledDropdown,
    DropdownMenu,
    Col,
    Modal,
    ModalBody,
    Button
} from 'reactstrap';
import { clearSession, getRealImageSrc, ip } from '../../session';

import { handFileActions, getFileIcon } from '../uosFileAction'
import PerfectScrollbar from 'react-perfect-scrollbar';

export default class FileInstance extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            pid: props.pid, sortOption: 0, show_rename_modal: false, show_video_instance: null, allow_user_upload: 0, current_id: null, current_fname: "", is_admin: 0, show_search_bar: props.show_search_bar !== undefined ? props.show_search_bar : false,
            layout: 1, dataLoaded: false, items: null, searchValue: props.searchValue, updateScrollBar: false, gridTemplateColumns: ""
        };
    }


    componentDidMount() {
        let session = window.localStorage;
        axios.post(session.ch_action_url + "/action/get_all_project_files", Qs.stringify({
            token: session.ch_token,
            id: this.state.pid
        })).then(res => {
            if (res.data.status === 0) {
                clearSession();
            } else if (res.data.status === 0) {
                Swal.fire(
                    'Operation Failed!',
                    res.data.info,
                    'error');
            }
            else {
                //let items = res.data.data;
                let items = this.sortFiles(res.data.data, this.state.sortOption);

                let gridTemplateColumns = this.getItemDimensions();
                this.setState({ items: items, current_fname: res.data.file_name, dataLoaded: true, gridTemplateColumns: gridTemplateColumns, is_admin: res.data.is_admin, allow_user_upload: res.data.allow_user_upload });
                window.addEventListener("resize", this.updateDimensions.bind(this));
            }
        });

    }


    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions.bind(this));
    }


    getItemDimensions() {
        let gridTemplateColumns = "";
        let div_element = document.getElementById('show_main_content_div_files');
        if (div_element === undefined || div_element === null) {
            return { width: "0", padding: "0px" };
        }
        let positionInfo = div_element.getBoundingClientRect();
        let div_width = positionInfo.width - 40;
        if (div_width < 600) {
            gridTemplateColumns = div_width + "px";
        }
        else {
            let max_width = 300;
            let min_width = 260;
            let pre_value = 0;
            for (let i = 1; i < 10; i++) {
                let value = div_width / (1.0 * i);

                if (value >= min_width && value <= max_width) {
                    let real_value = parseInt(value);
                    gridTemplateColumns = "repeat(" + i + "," + real_value + "px)";
                    break;
                }
                else if (pre_value > max_width && value < min_width) {
                    let real_value = parseInt(pre_value) - 1;
                    gridTemplateColumns = "repeat(" + (i - 1) + "," + real_value + "px)";
                    break;
                }
                pre_value = value;
            }
        }
        return gridTemplateColumns;
    }

    updateDimensions() {
        let gridTemplateColumns = this.getItemDimensions();
        this.setState({ gridTemplateColumns: gridTemplateColumns });
    }


    componentDidUpdate(prevProps, prevState) {
        if (this.state.pid !== prevState.pid) {
            let session = window.localStorage;
            axios.post(session.ch_action_url + "/action/get_all_project_files", Qs.stringify({
                token: session.ch_token,
                id: this.state.pid
            })).then(res => {
                if (res.data.status === -1) {
                    clearSession();
                } else if (res.data.status === 0) {
                    Swal.fire(
                        'Operation Failed!',
                        res.data.info,
                        'error');
                }
                else {
                    let items = this.sortFiles(res.data.data, this.state.sortOption);
                    this.setState({ items: items, is_admin: res.data.is_admin, allow_user_upload: res.data.allow_user_upload });
                }
            });
        }
    }

    sortFiles(items, option) {
        if (option === 1)//==="name"&&direction===1)// up
        {
            items.sort((a, b) => ((a.name) >= (b.name)) ? 1 : -1);
        }
        else if (option === 2)//"name"&&direction===0)// down
        {
            items.sort((a, b) => ((a.name) <= (b.name)) ? 1 : -1);
        }
        else if (option === 3)//"type"&&direction===1)// up
        {
            items.sort((a, b) => ((a.type) >= (b.type)) ? 1 : -1);
        }
        else if (option === 4)//"type"&&direction===0)// down
        {
            items.sort((a, b) => ((a.type) <= (b.type)) ? 1 : -1);
        }
        else if (option === 5)//"time"&&direction===1)// up
        {
            items.sort((a, b) => ((a.time) >= (b.time)) ? 1 : -1);
        }
        else if (option === 6)//"time"&&direction===0)// up
        {
            items.sort((a, b) => ((a.time) <= (b.time)) ? 1 : -1);
        }
        return items;
    }

    handleFolderFileAction(action_name, current_id, value_1, value_2) {
        if (action_name === "delete") {
            let final_this = this;
            handFileActions("delete", function () {
                let items = final_this.state.items;
                items = items.filter(item => item.id !== current_id);
                final_this.setState({ items: items });
            }, current_id);
        }
        else if (action_name === "show_upload_file_modal") {
            let fileInput = document.getElementById("uos_file_upload_box");
            fileInput.click();
        }
        else if (action_name === "show_create_folder_modal") {
            this.setState({ show_create_folder_modal: true });
        }
        else if (action_name === "create_new_folder") {
            let value = document.getElementById("p_new_name").value;
            let final_this = this;
            handFileActions("create_new_folder", function (data) {
                let items = final_this.state.items;
                //items.push(data);
                items.unshift(data);
                final_this.setState({ items: items, show_create_folder_modal: false });
            }, this.state.pid, value);
        }
        else if (action_name === "upload_files") {
            let fileinputs = document.getElementById("uos_file_upload_box");
            let final_this = this;
            handFileActions("upload_files", function (data) {
                let items = final_this.state.items;
                for (let i = 0; i < data.length; i++) {
                    //items.push(data[i]);
                    items.unshift(data[i]);
                }
                final_this.setState({ items: items });
            }, this.state.pid, fileinputs);

        }
        else if (action_name === "show_rename_modal") {
            let old_name = value_1;
            if (value_2 === 4) {
                old_name = old_name.substring(0, old_name.lastIndexOf("."));
            }

            this.setState({ current_id: current_id, p_old_name: old_name, p_old_type: value_2, show_rename_modal: true })
        }
        else if (action_name === "rename") {
            let new_name = document.getElementById("p_new_name").value;
            let final_this = this;
            handFileActions("rename", function (data) {
                let items = final_this.state.items;
                for (let i = 0; i < items.length; i++) {
                    if (items[i].id === final_this.state.current_id) {
                        items[i].name = new_name;
                        break;
                    }
                }
                document.getElementById("p_new_name").value = "";
                final_this.setState({ items: items, current_id: "", show_rename_modal: false, p_old_name: "" });
            }, this.state.current_id, this.state.p_old_name, new_name);
        }
        else if (action_name === "download") {
            let item = current_id;
            if (item.type === 2) {
                let url = "";
                if (item.parentid.endsWith("event_media")) {
                    url = ip + "/udata/usong/event_media/" + item.real_name;
                }
                else { url = ip + "/udata/usong/" + item.real_name; }
                url = "http://" + url;
                let link = document.createElement("a");
                link.download = item.name;
                link.href = url;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                link.remove();
                return;
            }
        }
        else if (action_name === "update_gallery") {
            let item = current_id;
            let session = window.localStorage;
            let status = item.is_in_gallery === 1 ? 0 : 1;
            axios.post(session.ch_action_url + "/action/update_project_gallery_status", Qs.stringify({
                token: session.ch_token,
                id: item.id,
                status: status
            })).then(res => {
                if (res.data.status === -1) {
                    clearSession();
                } else if (res.data.status === 0) {
                    Swal.fire(
                        'Operation Failed!',
                        res.data.info,
                        'error');
                }
                else {
                    let items = this.state.items;
                    for (let i = 0; i < items.length; i++) {
                        if (items[i].id === item.id) {
                            items[i].is_in_gallery = status;
                            break;
                        }
                    }
                    this.setState({ items: items });
                }
            });
        }
        else if (action_name === "allow_upload") {
            let item = current_id;

            let session = window.localStorage;
            let allow_user_upload = item.allow_user_upload === 1 ? 0 : 1;
            axios.post(session.ch_action_url + "/action/update_allow_user_upload_status", Qs.stringify({
                token: session.ch_token,
                id: item.id,
                allow_user_upload: allow_user_upload
            })).then(res => {
                if (res.data.status === -1) {
                    clearSession();
                } else if (res.data.status === 0) {
                    Swal.fire(
                        'Operation Failed!',
                        res.data.info,
                        'error');
                }
                else {
                    let items = this.state.items;
                    for (let i = 0; i < items.length; i++) {
                        if (items[i].id === item.id) {
                            items[i].allow_user_upload = allow_user_upload;
                            break;
                        }
                    }
                    this.setState({ items: items });
                }
            });
        }
        else if (action_name === "show_create_folder_modal") {

        }

    }

    getFileSize(size) {
        if (parseInt(size / (1024 * 1024)) > 0) {
            return parseInt(size / (1024 * 1024)) + "MB";
        }
        else if (parseInt(size / (1024)) > 0) {
            return parseInt(size / (1024)) + "KB";
        }
        else {
            return size + "B";
        }
    }

    goToFileInstance(item) {
        if (item.type === 2) {
            if (item.real_name.endsWith(".mp4")) {
                let url = window.location.origin + "/udata/usong/" + item.real_name;
                this.setState({ show_video_instance: url });
            }
            else {
                let url = "";
                url = ip + "/udata/usong/" + item.real_name;
                url = "http://" + url;
                //let url = window.location.origin + "/udata/usong/" +item.real_name;
                window.open(url, "_blank");
            }

            return;
        } else {
            let href = window.location.origin + "/resource/" + item.id;
            window.location.href = href;
            // window.history.pushState({}, 0, href);
            // if (item.id === "0") {
            //     this.setState({ pid: item.id, current_fname: "", current_id: null });
            // }
            // else {
            //     this.setState({ pid: item.id, current_fname: item.name, current_id: item.id });
            // }

        }
    }

    updateSortOption(option) {
        this.props.updateSortOption(option);
    }

    getInstanceIcon(item) {
        let type = item.type;
        let name = item.name;

        if (type === 1 && item.allow_user_upload === 0 && item.is_in_gallery === 0) {
            return <FontAwesomeIcon icon={['fas', 'folder']} style={{ fontSize: "40px" }} />;
        }
        else if (type === 1 && (item.allow_user_upload === 1 || item.is_in_gallery === 1)) {
            return <FontAwesomeIcon icon={['fas', 'folder']} style={{ fontSize: "40px" }} className="text-warning" />;
        }
        else if (type === 2) {
            let name_type = name.substring(name.lastIndexOf(".") + 1);
            name_type = name_type.toLowerCase();
            if (name_type === "jpeg" || name_type === "jpg" || name_type === "png" || name_type === "gif") {
                let url = "";
                url = "udata/usong/" + item.real_name;
                //url = "http://" + url;
                return <img src={getRealImageSrc(url)} all="" style={{ width: "40px", height: "40px" }} />
            }
            return getFileIcon(name);
        }
        else {
            return <FontAwesomeIcon icon={['fas', 'file']} style={{ fontSize: "40px" }} />;
        }
    }

    getInstanceRightMenu(item) {
        if (item.id.endsWith("event_media")) {
            return <Menu id={item.id + "_tree_menu"} key={item.id + "_tree_menu_instance"}>
                <Item onClick={(e) => this.goToFileInstance(item)}><FontAwesomeIcon icon={['fas', 'arrows-alt']} className="mr-1" style={{ position: "relative", top: "3px" }} /><span>Open</span></Item>
            </Menu>
        }
        return <Menu id={item.id + "_tree_menu"} key={item.id + "_tree_menu_instance"}>
            <Item onClick={(e) => this.goToFileInstance(item)}><FontAwesomeIcon icon={['fas', 'arrows-alt']} className="mr-1" style={{ position: "relative", top: "3px" }} /><span>Open</span></Item>
            {item.role === 1 && <Item onClick={(e) => this.handleFolderFileAction("show_rename_modal", item.id, item.name, item.type)}><FontAwesomeIcon icon={['fas', 'edit']} className="mr-1" style={{ position: "relative", top: "3px" }} /><span>Rename</span></Item>}
            {item.type === 2 && <Item onClick={(e) => this.handleFolderFileAction("download", item)}><FontAwesomeIcon icon={['fas', 'download']} className="mr-1" style={{ position: "relative", top: "3px" }} /><span>Download</span></Item>}
            {item.role === 1 && item.type === 1 && item.allow_user_upload === 0 && <Item onClick={(e) => this.handleFolderFileAction("allow_upload", item)}><FontAwesomeIcon icon={['fas', 'upload']} className="mr-1" style={{ position: "relative", top: "3px" }} /><span>Enable Upload</span></Item>}
            {item.role === 1 && item.type === 1 && item.allow_user_upload === 1 && <Item onClick={(e) => this.handleFolderFileAction("allow_upload", item)}><FontAwesomeIcon icon={['fas', 'upload']} className="mr-1" style={{ position: "relative", top: "3px" }} /><span>Diable Upload</span></Item>}
            {item.role === 1 && item.type === 1 && item.is_in_gallery === 0 && <Item onClick={(e) => this.handleFolderFileAction("update_gallery", item)}><FontAwesomeIcon icon={['fas', 'image']} className="mr-1" style={{ position: "relative", top: "3px" }} /><span>In-Gallery</span></Item>}
            {item.role === 1 && item.type === 1 && item.is_in_gallery === 1 && <Item onClick={(e) => this.handleFolderFileAction("update_gallery", item)}><FontAwesomeIcon icon={['fas', 'image']} className="mr-1" style={{ position: "relative", top: "3px" }} /><span>Out-Gallery</span></Item>}
            {item.role === 1 && <Item onClick={(e) => this.handleFolderFileAction("delete", item.id)}><FontAwesomeIcon icon={['fas', 'trash']} className="mr-1" style={{ position: "relative", top: "3px" }} /><span>Delete</span></Item>}
        </Menu>
    }

    getInstanceMenu(item) {
        if (item.id.endsWith("event_media")) {
            return <DropdownMenu right>
                <div onClick={(e) => this.goToFileInstance(item)} role="menuitem"><span className="dropdown-item">
                    <FontAwesomeIcon icon={['fas', 'arrows-alt']} className="mr-1" style={{ position: "relative", top: "3px" }} />
                    <span>Open</span></span>
                </div></DropdownMenu>;
        }
        return <DropdownMenu right id={item.id + "_tree_menu"} key={item.id + "_tree_menu_instance"}>
            <div role="menuitem" onClick={(e) => this.goToFileInstance(item)}><span className="dropdown-item"><FontAwesomeIcon icon={['fas', 'arrows-alt']} className="mr-1" style={{ position: "relative", top: "3px" }} /><span>Open</span></span></div>
            {item.role === 1 && <div role="menuitem" onClick={(e) => this.handleFolderFileAction("show_rename_modal", item.id, item.name, item.type)}><span className="dropdown-item"><FontAwesomeIcon icon={['fas', 'edit']} className="mr-1" style={{ position: "relative", top: "3px" }} /><span>Rename</span></span></div>}
            {item.type === 2 && <div role="menuitem" onClick={(e) => this.handleFolderFileAction("download", item)}><span className="dropdown-item"><FontAwesomeIcon icon={['fas', 'download']} className="mr-1" style={{ position: "relative", top: "3px" }} /><span>Download</span></span></div>}
            {item.role === 1 && item.type === 1 && item.allow_user_upload === 0 && <div role="menuitem" onClick={(e) => this.handleFolderFileAction("allow_upload", item)}><span className="dropdown-item"><FontAwesomeIcon icon={['fas', 'upload']} className="mr-1" style={{ position: "relative", top: "3px" }} /><span>Enable Upload</span></span></div>}
            {item.role === 1 && item.type === 1 && item.allow_user_upload === 1 && <div role="menuitem" onClick={(e) => this.handleFolderFileAction("allow_upload", item)}><span className="dropdown-item"><FontAwesomeIcon icon={['fas', 'upload']} className="mr-1" style={{ position: "relative", top: "3px" }} /><span>Diable Upload</span></span></div>}
            {item.role === 1 && item.type === 1 && item.is_in_gallery === 0 && <div role="menuitem" onClick={(e) => this.handleFolderFileAction("update_gallery", item)}><span className="dropdown-item"><FontAwesomeIcon icon={['fas', 'image']} className="mr-1" style={{ position: "relative", top: "3px" }} /><span>In-Gallery</span></span></div>}
            {item.role === 1 && item.type === 1 && item.is_in_gallery === 1 && <div role="menuitem" onClick={(e) => this.handleFolderFileAction("update_gallery", item)}><span className="dropdown-item"><FontAwesomeIcon icon={['fas', 'image']} className="mr-1" style={{ position: "relative", top: "3px" }} /><span>Out-Gallery</span></span></div>}
            {item.role === 1 && <div role="menuitem" onClick={(e) => this.handleFolderFileAction("delete", item.id)}><span className="dropdown-item"><FontAwesomeIcon icon={['fas', 'trash']} className="mr-1" style={{ position: "relative", top: "3px" }} /><span>Delete</span></span></div>}
        </DropdownMenu>
    }

    getInstanceStatusIcon(item) {
        // if (this.state.layout === 2) {
        //     return <td className="text-center">
        //         {item.type === 1 && <span className="font-weight-bold">{item.files_number === 0 ? "Empty" : (item.files_number + " Files")}</span>}
        //         {item.type === 2 && <span className="font-weight-bold">{this.getFileSize(item.file_size)}</span>}
        //     </td>
        // }
        // else {
        //     return <div className="mt-2">
        //         {item.type === 1 && <span className="font-weight-bold">{item.files_number === 0 ? "Empty" : (item.files_number + " Files")}</span>}
        //         {item.type === 2 && <span className="font-weight-bold">{this.getFileSize(item.file_size)}</span>}
        //     </div>
        // }

        if (this.state.layout === 2) {
            return <td className="text-center">
                <span className="font-weight-bold">{"by " + item.uname}</span>
            </td>
        }
        else {
            return <div className="mt-2 text-truncate" style={{ maxWidth: "160px" }}>
                <span className="font-weight-bold">{"by " + item.uname}</span>
            </div>
        }
    }

    handleSearchAction(e, action_name) {
        if (action_name === "keydown") {
            if (e.key === "Enter" && e.target.value !== "") {
                this.setState({ searchValue: e.target.value });
            }
        }
        else if (action_name === "onchange") {
            this.setState({ searchValue: e.target.value });
        }
    }

    handleSearchFilter(item) {
        if (this.state.searchValue === "" || (this.state.searchValue !== "" && (item.name.indexOf(this.state.searchValue) >= 0))) {
            return true;
        }

        if (this.state.searchValue !== "" && item.uname.indexOf(this.state.searchValue) >= 0) {
            return true;
        }

        return false;
    }

    render() {
        return (
            <Fragment>
                <PerfectScrollbar options={{ suppressScrollX: true, wheelPropagation: true }}>
                    <div className="pt-2 pb-3" style={{ height: "calc(100vh - 90px)" }}>
                        <div className="pb-3 pt-2" style={{ maxWidth: "1200px", margin: "auto" }}>
                            <input type="file" multiple style={{ display: "none" }} id="uos_file_upload_box" onChange={(e) => this.handleFolderFileAction("upload_files")} />
                            <Row style={{ borderBottom: "1px gray solid" }}>
                                <Col md={this.state.show_search_bar ? "4" : "6"} className="pb-2">
                                    <div className="pl-3 pt-3 pb-2">
                                        <span style={{ cursor: "pointer" }} onClick={(e) => this.goToFileInstance({ id: "0", name: "", type: 1 })}>Resources</span>
                                        {this.state.current_fname !== "" && <span style={{ cursor: "pointer" }} onClick={(e) => this.goToFileInstance({ id: this.state.current_id, name: this.state.current_fname, type: 1 })}>{"/" + this.state.current_fname}</span>}
                                    </div>
                                </Col>
                                {this.state.show_search_bar && <Col md="4" className="pb-2 pt-2">
                                    <div className={clsx("ml-2 search-wrapper search-wrapper--alternate", 'is-active')}>
                                        <span className="icon-wrapper text-black">
                                            <FontAwesomeIcon icon={['fas', 'search']} />
                                        </span>
                                        <Input id="file_body_search" key="file_body_search" style={{ borderColor: "#b2b3cc" }} onKeyPress={(e) => this.handleSearchAction(e, "keydown")} onChange={(e) => this.handleSearchAction(e, "onchange")} className="rounded-pill" placeholder={"searching..."} type="search" />
                                    </div>
                                </Col>}
                                {(this.state.is_admin === 1 || this.state.allow_user_upload === 1) && <Col md={this.state.show_search_bar ? "4" : "6"} className="pb-2">
                                    <div className="pl-3 pt-2 pb-2">
                                        {this.state.is_admin === 1 && <Button className="ml-2 btn-primary" color="primary" onClick={(e) => this.handleFolderFileAction("show_create_folder_modal")} size="sm" key="create_file_button" id="create_file_button" >Create Folder</Button>}
                                        <Button className="ml-2 btn-primary" color="primary" onClick={(e) => this.handleFolderFileAction("show_upload_file_modal")} size="sm" key="upload_file_button" id="upload_file_button" >Upload Files</Button>
                                    </div>
                                </Col>}
                            </Row>
                            <div className="pt-3 pb-3 utb_card" id="show_main_content_div_files" style={{ gridTemplateColumns: this.state.gridTemplateColumns, cursor: "pointer" }}>
                                {this.state.items != null && this.state.items.length > 0 && this.state.items.map(item => (
                                    this.handleSearchFilter(item) &&
                                    <div id={"uos_instance_div_" + item.id} className="p-2" key={"uos_instance_div_" + item.id}>
                                        <Card id={item.id + "_tree_menu"} key={item.id + "_tree_menu"} className="card-box mt-2 mb-2 p-2 text-left rounded border-0 cursor_pointer file_instance_card">
                                          <div className="card-tr-actions">
                                                    <UncontrolledDropdown className="ml-auto position-relative align-self-center">
                                                        <DropdownToggle size="sm" color="first" style={{ minWidth: "24px", backgroundColor: "#3f4e5a" }} className="font-size-md  d-24 p-0 rounded-circle border-0">
                                                            <div >
                                                                <FontAwesomeIcon icon={['fas', 'ellipsis-v']} />
                                                            </div>
                                                        </DropdownToggle>
                                                        {this.getInstanceMenu(item)}
                                                    </UncontrolledDropdown>
                                                </div>
                                            <div className="d-flex align-items-center" onClick={(e) => this.goToFileInstance(item)}>
                                                <div className="d-50 rounded text-black mr-3 text-center">
                                                    {this.getInstanceIcon(item)}
                                                </div>
                                                
                                                <div className="text-black-50">
                                                    <div className="text-black font-weight-bold text-truncate" style={{ maxWidth: "160px" }} title={item.name} id={"name_span_" + item.id}>{item.name}</div>
                                                    {this.getInstanceStatusIcon(item)}
                                                    <div className="font-size-sm mt-2">
                                                        {item.allow_user_upload === 0 && item.is_in_gallery === 0 && <FontAwesomeIcon icon={['fas', 'clock']} className="mr-2" />}
                                                        {item.is_in_gallery === 1 && <FontAwesomeIcon icon={['fas', 'star']} className="mr-2" />}
                                                        {item.allow_user_upload === 1 && <FontAwesomeIcon icon={['fas', 'upload']} className="mr-2" />}
                                                        <span className="text-black">{item.datetime}</span></div>
                                                </div>
                                            </div>
                                        </Card>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </PerfectScrollbar>
                <Modal zIndex={2000} centered isOpen={this.state.show_create_folder_modal}>
                    <ModalHeader toggle={() => this.setState({ show_create_folder_modal: false })}>Create New Folder</ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label htmlFor="p_new_name">{"New Name--(should only contain numbers, alphbets, underscore, dash and chinese characters. The length should be [2-20]!"}</Label>
                            <Input type="text" name="p_new_name" id="p_new_name" defaultValue={""} />
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="link" className="btn-link-dark" onClick={() => this.setState({ show_create_folder_modal: false })}>Close</Button>{' '}
                        <Button color="primary" className="ml-auto" onClick={() => this.handleFolderFileAction("create_new_folder")}>Create</Button>
                    </ModalFooter>
                </Modal>

                <Modal zIndex={2000} centered isOpen={this.state.show_rename_modal}>
                    <ModalHeader toggle={() => this.setState({ show_rename_modal: false, current_id: "" })}>Rename</ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Input type="text" name="p_new_name" id="p_new_name" defaultValue={this.state.p_old_name} />
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="link" className="btn-link-dark" onClick={() => this.setState({ show_rename_modal: false, current_id: "" })}>Close</Button>{' '}
                        <Button color="primary" className="ml-auto" onClick={() => this.handleFolderFileAction("rename")}>Submit</Button>
                    </ModalFooter>
                </Modal>

                <Modal zIndex={2000} centered size="lg" style={{ maxWidth: "1000px", top: "65px" }} isOpen={this.state.show_video_instance !== null ? true : false}>
                    <ModalBody>
                        <button type="button" className="close" aria-label="Close" onClick={() => this.setState({ show_video_instance: null })}><span aria-hidden="true">×</span></button>
                        <video style={{ width: "100%", maxWidth: "100%" }} controls>
                            <source src={this.state.show_video_instance} type="video/mp4" />
                        </video>
                    </ModalBody>
                </Modal>

            </Fragment>
        );
    }
}

